import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";
import { useGetSingleHrdFormulaireVersionQuery } from "@api/Hrd/HrdFormulaireApi.ts";
import Loader from "@components/Loader.tsx";
import { ElementNotFound } from "@components/errors/ElementNotFound.tsx";
import { HrdFormulaireVersionContext } from "@contexts/HrdFormulaireVersionContext.tsx";
import { HrdFormulaireSummaryCard } from "@components/hrd/formulaires/HrdFormulaireSummaryCard.tsx";
import { Stack } from "@mui/material";

export const Route = createFileRoute("/_dashboard/hrd/formulaires/$uuid")({
  beforeLoad: ({ params, location }) => {
    if (location.pathname === `/hrd/formulaires/${params.uuid}`) {
      throw redirect({
        to: "/hrd/formulaires/$uuid/$tab",
        params: { uuid: params.uuid, tab: "formulaire" },
      });
    }
  },
  component: HrdFormulaireLayout,
});

function HrdFormulaireLayout() {
  const { uuid } = Route.useParams();
  const { data, isLoading } = useGetSingleHrdFormulaireVersionQuery(uuid);

  if (isLoading) return <Loader />;
  if (!data) return <ElementNotFound />;

  return (
    <HrdFormulaireVersionContext value={data}>
      <Stack spacing={2}>
        <HrdFormulaireSummaryCard hrdFormulaire={data} />
        <Outlet />
      </Stack>
    </HrdFormulaireVersionContext>
  );
}
